import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Teacher\ScheduleOccurrenceController::edit
* @see app/Http/Controllers/Teacher/ScheduleOccurrenceController.php:16
* @route '/teacher/schedules/{schedule}/occurrences/{occurrenceDate}/edit'
*/
export const edit = (args: { schedule: string | { id: string }, occurrenceDate: string | number } | [schedule: string | { id: string }, occurrenceDate: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: edit.url(args, options),
    method: 'post',
})

edit.definition = {
    methods: ["post"],
    url: '/teacher/schedules/{schedule}/occurrences/{occurrenceDate}/edit',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Teacher\ScheduleOccurrenceController::edit
* @see app/Http/Controllers/Teacher/ScheduleOccurrenceController.php:16
* @route '/teacher/schedules/{schedule}/occurrences/{occurrenceDate}/edit'
*/
edit.url = (args: { schedule: string | { id: string }, occurrenceDate: string | number } | [schedule: string | { id: string }, occurrenceDate: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            schedule: args[0],
            occurrenceDate: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        schedule: typeof args.schedule === 'object'
        ? args.schedule.id
        : args.schedule,
        occurrenceDate: args.occurrenceDate,
    }

    return edit.definition.url
            .replace('{schedule}', parsedArgs.schedule.toString())
            .replace('{occurrenceDate}', parsedArgs.occurrenceDate.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\ScheduleOccurrenceController::edit
* @see app/Http/Controllers/Teacher/ScheduleOccurrenceController.php:16
* @route '/teacher/schedules/{schedule}/occurrences/{occurrenceDate}/edit'
*/
edit.post = (args: { schedule: string | { id: string }, occurrenceDate: string | number } | [schedule: string | { id: string }, occurrenceDate: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: edit.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Teacher\ScheduleOccurrenceController::destroy
* @see app/Http/Controllers/Teacher/ScheduleOccurrenceController.php:54
* @route '/teacher/schedules/{schedule}/occurrences/{occurrenceDate}'
*/
export const destroy = (args: { schedule: string | { id: string }, occurrenceDate: string | number } | [schedule: string | { id: string }, occurrenceDate: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/teacher/schedules/{schedule}/occurrences/{occurrenceDate}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Teacher\ScheduleOccurrenceController::destroy
* @see app/Http/Controllers/Teacher/ScheduleOccurrenceController.php:54
* @route '/teacher/schedules/{schedule}/occurrences/{occurrenceDate}'
*/
destroy.url = (args: { schedule: string | { id: string }, occurrenceDate: string | number } | [schedule: string | { id: string }, occurrenceDate: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            schedule: args[0],
            occurrenceDate: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        schedule: typeof args.schedule === 'object'
        ? args.schedule.id
        : args.schedule,
        occurrenceDate: args.occurrenceDate,
    }

    return destroy.definition.url
            .replace('{schedule}', parsedArgs.schedule.toString())
            .replace('{occurrenceDate}', parsedArgs.occurrenceDate.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Teacher\ScheduleOccurrenceController::destroy
* @see app/Http/Controllers/Teacher/ScheduleOccurrenceController.php:54
* @route '/teacher/schedules/{schedule}/occurrences/{occurrenceDate}'
*/
destroy.delete = (args: { schedule: string | { id: string }, occurrenceDate: string | number } | [schedule: string | { id: string }, occurrenceDate: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const occurrences = {
    edit: Object.assign(edit, edit),
    destroy: Object.assign(destroy, destroy),
}

export default occurrences